module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJ1dGlsaXR5L2NhbGVuZGFyIj4NCjxwYXRoIGlkPSJzdHJva2UiIGQ9Ik0yMiA4VjIuODE4MjlIMTcuNU0yMiA4VjIxSDJWOE0yMiA4SDJNMiA4VjIuODE4MjlINi41TTEwIDQuNjM2MzRWMU0xNCA0LjYzNjM0VjEiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9nPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_calendar.svg
// module id = iWp6
// module chunks = 1